import Popover from "@material-ui/core/Popover";
import { ReactComponent as Download } from "assets/icons/Download.svg";
import { ReactComponent as Eye } from "assets/icons/Eye2.svg";
import { ReactComponent as Share } from "assets/icons/Share.svg";
import { ReactComponent as Slip } from "assets/icons/Slip.svg";
import { ReactComponent as Transactions } from "assets/icons/Transactions.svg";
import { ReactComponent as Unbatch } from "assets/icons/Unbatch.svg";
import React from "react";
import styled from "styled-components";
import ActionSvgComponent from "../assets/icons/svg/actionSvg";
import "./style.scss";

const Box = styled.div`
  width: 363px;
  height: 49px;
  display: flex;
  > :nth-child(1) {
    width: 100%;
    text-align: start;
    padding-left: 40px;
  }
`;
const TransactionsBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > :nth-child(2) {
    display: flex;
    width: 29%;
    justify-content: space-evenly;
  }
`;
export default function PenddingPopover({
  style,
  id: batch_id,
  Undeposit,
  markAsSynced,
  generatePdf,
  generateDepositeExcel,
  shareDepositePdf,
  shareLoading,
  row
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleOnClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <ActionSvgComponent
        height={style ? style.height : 14}
        width={style ? style.width : 14}
        onClick={handleOnClick}
        color={style && style.color}
      />

      <div>
        {" "}
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Box className="action-pop-over " onClick={() => Undeposit()}>
            <div className="finance-pop-over">
              <Unbatch
                style={{
                  marginRight: "13.5px",
                }}
                width={23} height={23}
              />
              <span style={{ color: "#F1585E" }}>Undeposit</span>
            </div>
          </Box>
          <Box className="action-pop-over " onClick={() => markAsSynced()}>
            <div className="finance-pop-over">
              <Slip
                style={{
                  marginRight: "13.5px",
                }}
                width={23} height={23}
              />
              <span style={{ color: "#4D5565" }}>{row?.isSynced ? "Mark as not Synced" : "Mark as Synced"}</span>
            </div>
          </Box>
          <Box className="action-pop-over ">
            <TransactionsBox className="finance-pop-over">
              <div>
                <Transactions
                  style={{
                    marginRight: "13.5px",
                  }}
                  width={23} height={23}
                />
                <span style={{ color: "#4D5565" }}>Transactions</span>
              </div>
              <div>
                <Download onClick={generateDepositeExcel} />
                {shareLoading ? <span className="spinner spinner-gray mr-2"></span> : <Share onClick={shareDepositePdf}/>}
              </div>
            </TransactionsBox>
          </Box>
          {/* <Box className="action-pop-over ">
            <TransactionsBox className="finance-pop-over" onClick={generatePdf}>
              <div>
                <Slip
                  style={{
                    marginRight: "13.5px",
                  }}
                />
                <span style={{ color: "#4D5565" }}>Slip</span>
              </div>
              <div>
                <Eye />
                <Download />
                <Share />
              </div>
            </TransactionsBox>
          </Box> */}
        </Popover>
      </div>
    </div>
  );
}
